export type UserStatus = "Active" | "Pending" | "Disabled";

export interface User {
  userID: string;
  name: string;
  email: string;
  status: UserStatus;
  locationID: string;
}

export interface AddEditUserData {
  name: string;
  email: string;
  locationID: string;
}

export interface UserApiResponse {
  data: User[];
  meta: {
    total: number;
    pageNo: number;
    totalPages: number;
    hasNextPage: boolean;
    perPage: string;
  };
}

export interface UserDetails {
  userID: string;
  locationID: string;
  email: string;
  name: string;
  status: string;
  disabled: boolean;
  userType: string;
  Location: {
    locationID: string;
    locationName: string;
    geoLocation: string;
    address: string;
  };
}

export interface UserDetailsResponse {
  data: UserDetails;
}

export type UserActionType = "delete" | "status" | "resend";

export interface UserActionDialogState {
  type: UserActionType | null;
  isOpen: boolean;
  isLoading: boolean;
  user: User | null;
}

export enum UserType {
  ADMINISTRATOR = "Administrator",
  OPERATOR = "Operator",
  APP_USER = "AppUser",
  DISPATCHER = "FirstResponder",
  SYSTEM="SYSTEM"
}
